
    import Vue from 'vue'
    import router from "../router";
    import ReziseSensor from "css-element-queries/src/ResizeSensor";
    import VuePlotly from '@statnett/vue-plotly'
    import { home } from '../config/home'


    export default Vue.extend({
        name: 'About',
        metaInfo: {
            title: 'QDRA',
            meta : [
                {
                    name: 'description',
                    content : 'Thunderstorms and Cyclones are a part of life in Australia. The Queensland Disaster Research Alliance (QDRA) is a state-based University collaboration that aims to grow and integrate Queensland’s capability and capacity to deliver high impact and at-scale disaster management research outcomes for the state, nationally and internationally.'
                },
                {
                    name: 'keywords',
                    content : 'cyclones, thunderstorms, disasters, floods, fires, Australia, Queensland, houses, storm preparation, cyclone, weather, storm, protection, collaboration, disaster management, research, education'
                }
            ]
        },
        components: {
        },

        data: () => ({

            "frames": [],
            "home" : home,
            options: {
                "autoresize": true,
                "autosize": true,
                "autosizable": true,
                "reponsive": true
            },
            autoresize: true,
            articles: [

                {
                    src: 'pg.png',
                    title: 'Dr Paul Greenfield',
                    subtitle: 'Queensland Disaster Research Alliance (QDRA) Chair',
                    text: 'Dr Greenfield is Chair of Queensland Disaster Research Alliance (QDRA). He has extensive experience as a Board Director. He has worked widely with industry on a range of projects spanning many sectors. ',
                    //'<p> Email: <a href = "mailto: patrick.driscoll@jcu.edu.au">patrick.driscoll@jcu.edu.au</a></p>' +
                    //'\n' +
                    //'<p>Phone: +61 7 4781 4986</p>'
                    //',
                    link: 'greenfield'
                },

                {
                    src: 'pd.jpeg',
                    title: 'Mr Patrick Driscoll',
                    subtitle: 'James Cook University',
                    text: 'Patrick has worked extensively in the delivery of digital business solutions, business analysis, and project management to a variety of businesses. He is currently studying a masters in Urban Planning and Design. ',
                    //'<p> Email: <a href = "mailto: patrick.driscoll@jcu.edu.au">patrick.driscoll@jcu.edu.au</a></p>' +
                    //'\n' +
                    //'<p>Phone: +61 7 4781 4986</p>'
                    //',
                    link: 'patrick'
                },

                {
                    src: 'hk.jpg',
                    title: 'Associate Professor Helen Keen-Dyer',
                    subtitle: 'Central Queensland University ',
                    text: 'Helen Keen-Dyer is an Associate Professor of Disaster Management and Health in the College of Science and Sustainability. She is part of the CQ University Operational Readiness and the Resilience Research Clusters. ',
                    link: 'helen'
                },

                {
                    src: 'sc.jpg',
                    title: 'Dr Savindi Caldera ',
                    subtitle: 'University of the Sunshine Coast ',
                    text: 'Dr Savindi is a Lecturer in Environmental Management at the School of Science, Technology and Engineering, University of Sunshine Coast. She is strongly positioned in the national research community as an Early-Mid Career Researcher (EMCR). ',
                    link: 'savindi'
                },

                {
                    src: 'jr.jpg',
                    title: 'Associate Professor Jamie Ranse ',
                    subtitle: 'Griffith University',
                    text: 'Associate Professor Dr Jamie Ranse is recognised internationally for his work focusing on strengthening health systems for disruptive events that are either unplanned (such as disasters / public health emergencies / extreme weather) or planned.',
                    link: 'ranse'
                },

                {
                    src: 'as.jpg',
                    title: 'Associate Professor Alastair Stark',
                    subtitle: 'University of Queensland',
                    text: 'Alastair Stark is an Associate Professor in Public Policy at the University of Queensland and the Director of the School of Political Science’s Graduate Centre. Alastair specializes in the study of crisis and disaster management. ',
                    link: 'stark'
                },





                {
                    src: 'sb.jpg',
                    title: 'Professor Scott Bryan ',
                    subtitle: 'Queensland University of Technology',
                    text: 'Professor Scott Bryan is an Earth Scientist, an Academic Lead and previously been Acting Head for the School of Earth & Atmospheric Sciences. He received the 2016 QUT Vice-Chancellor’s Award for Excellence. ',
                    link: 'scott'
                },



                {
                    src: 'gs.jpg',
                    title: 'Dr Gudrun Seynsche',
                    subtitle: 'University of Southern Queensland',
                    text: 'Dr Gudrun is a Director (Research Partnerships), in the Office of the Deputy Vice-Chancellor (Research and Innovation) at the University of Southern Queensland. She is responsible for providing leadership to staff across the University.',
                    link: 'gudrun'
                },




            ],
            articles2: [
                {
                    src: 'pb.jpg',
                    title: 'Dr Paul Barnes, Manager',
                    subtitle: 'Flinders University ',
                    text: 'Paul has over 25 years of experience as an applied academic and public sector manager covering emergency and risk management, and policy development on disaster risk reduction at both State and Federal levels.<p> Email: <a href = "mailto: tbd">email@university.com</a></p>' +
                    '\n' +
                    '<p>Phone: tbd</p>',
                    link: 'paul'
                },
            ],
            partners2: [
                {
                    src: 'QLDGovt-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
            ],
            partners1: [
                {
                    src: 'shedsafe-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'MasterBuilders-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'townsville-city-council-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'IAG-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'RACQ-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },

                {
                    src: 'stramit-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'WillisRe-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'campbell.jpeg',
                    title: '',
                    text: '',
                    link: 'https://www.campbellsci.com.au/'
                },
                {
                    src: 'bluescope.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'Suncorp-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'RMS-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
                {
                    src: 'rtaa-logo.jpeg',
                    title: '',
                    text: '',
                    link: 'blah'
                },
            ],
            examples: [
                {
                    src: 'damage-examples/minor.jpg',
                    title: 'Minor Damage',

                },
                {
                    src: 'damage-examples/moderate.jpg',
                    title: 'Moderate Damage',

                },
                {
                    src: 'damage-examples/severe.jpg',
                    title: 'Severe Damage',

                },
            ],
            videos: [
                {
                    src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'approvals'
                },

                {
                    src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                    title: 'Understand How Winds Affect Houses',
                    text: 'Understand wind loads and learn about the principles of retrofitting.',
                    link: 'wind'
                },
                {
                    src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                    title: 'Resources for Building Professionals',
                    text: 'Here are some resources for building professionals.',
                    link: 'resources'
                },
            ],
            people: [
                {
                    icon: 'pd.jpeg',
                    title: 'Patrick Driscoll',
                    subtitle: 'Director and Business Development Manager',
                    text: 'Patrick has worked extensively in the delivery of digital business solutions, business analysis, and project management to a variety of businesses. He is currently studying a masters in Urban Planning and Design.',
                    link: 'resilience',
                    highlight: false,
                    elevation: 0,
                    color: "grey darken-1"
                },
                {
                    icon: 'kp.jpeg',
                    title: 'TESTING',
                    subtitle: 'NATA ACCREDITED Material Testing Services',
                    text: 'We have in-house expertise and a fully equipped facility to help with your testing needs.',
                    link: 'testing',
                    highlight: false,
                    elevation: 0,
                    color: "grey darken-1"
                },
                {
                    icon: 'dh.png',
                    title: 'WIND ENGINEERING',
                    subtitle: '2.5m x 2.0m x 22m Boundary Layer Wind Tunnel',
                    text: 'Our research finds many practical applications in wind loading standards and building codes of practice.',
                    link: 'wind',
                    highlight: true,
                    elevation: 0,
                    color: "grey darken-1"
                },
                {
                    icon: 'si.jpeg',
                    title: 'WATER INGRESS',
                    subtitle: 'At the forefront of damage investigations',
                    text: 'We try to understand what building products and systems perform well, as well as identifying areas for improvement.',
                    link: 'water',
                    highlight: true,
                    elevation: 0,
                    color: "grey darken-1"
                },
                /*{
                    icon: 'mdi-home-roof',
                    title: 'LEVEL 4',
                    subtitle: 'Roof and Wall Tie-Down Retrofit',
                    text: 'Coming Up Soon.',
                    link: 'todo',
                    highlight: false
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Select a Level of Retrofitting',
                    text: 'Some retrofitting tasks should be performed before others.',
                    link: 'select/levels'
                },
                {
                    icon: 'mdi-home',
                    title: 'Select Your House-Type to get Customised Retrofit Details',
                    text: 'Select the category your house falls in. This will help you decide which retrofits are suitable.',
                    link: 'select'
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },
                {
                    icon: 'mdi-playlist-check',
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },*/
                /*,
                 {
                     icon: 'mdi-weather-windy',
                     title: 'Understand Wind Loads and House Structures',
                     text: 'Understand the relationship between wind loads and house structures.',
                     link: 'select/wind'
                 },
                 {
                     icon: 'mdi-ruler-square',
                     title: 'Understand the Principles of Retrofitting',
                     text: 'In order to protect your house you must understand the basics.',
                     link: 'select/principles'
                 }*/
            ],
            partners: [
                {
                    src: 'geo-logo.jpg',
                    ratio: 3.41,
                    title: 'Get Approvals and Contact Your Builder',
                    text: 'Get approvals from authorities and contact a licensed builder.',
                    link: 'select/approvals'
                },
                {
                    src: 'bush-logo.jpg',
                    title: 'Window and Door Protection',
                    text: 'Protecting windows and door can reduce the risk of internal pressurization and water ingress.',
                    link: 'resources',
                    ratio: 2.68
                },
                /*  {
                      src: 'cts-logo.jpg',
                      title: 'Contact Your Builder',
                      text: 'Funding and incentive schemes.',
                      link: 'select/approvals',
                      ratio: 2.32
                  },*/
            ],
        }),
        methods: {
            gotoSelect() {
                router.push('/select').catch(err => {
                    return err
                })
            },
            gotoHome() {
                router.push('/').catch(err => {
                    return err
                })
            },
            gotoWind() {
                router.push('/wind').catch(err => {
                    return err
                })
            },
            gotoResources() {
                router.push('/resources').catch(err => {
                    return err
                })

            }
        },
        computed: {
            minHeight () {
                const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'

                return `calc(${height} - ${this.$vuetify.application.top}px)`
            },
        }

    })
